import React from "react"
import { Link } from "gatsby"
import parse from "html-react-parser"
import { Container, Row } from "react-bootstrap"

const PostsNavigation = ({ data  }) => {
  const {previous, next} = data;
  return (

    <div className="article-slider-sec">
      <Container fluid>
        <Row>
          <div className="article-slider1">
            {previous && (
              <div className="item ar-lft-sec"
                   style={{
                     background: `url(${previous?.featuredImage?.node?.localFile?.publicURL}) 0 0 no-repeat`,
                     backgroundSize: "cover",
                   }}>
                <div className="article-box">
                  <Link to={previous.uri} className="text-end text-decoration-none">
                    <div className="article-dir-title text-right">Previous Article</div>
                    <p className="text-right">{parse(previous.title)}</p>
                  </Link>
                </div>
              </div>
            )}


            {next && (
              <div className="item ar-rt-sec"
                   style={{
                     background: `url(${next?.featuredImage?.node?.localFile?.publicURL}) 0 0 no-repeat`,
                     backgroundSize: "cover",
                   }}>
                <div className="article-box">
                  <Link to={next.uri} className=" text-decoration-none">
                    <div className="article-dir-title">Next Article</div>
                    <p>{parse(next.title)}</p>
                  </Link>
                </div>
              </div>
            )}

          </div>
        </Row>
      </Container>
    </div>
  )
}

export default PostsNavigation
